import moment, { Moment } from 'moment'
import React, { useEffect, useState } from 'react'
import { Route, Switch } from 'react-router-dom'

import { useAppDispatch, useAppSelector } from '../../App/Hooks/reduxHooks'
import { activeEstablishmentSelector } from '../../Establishment/Store/reducer'
import OverviewLastMinute from '../LastMinute/Overview/Overview'
import Overview from '../WaitingList/components/Overview/Overview'
import Create from '../WaitingList/crudActions/Create/Create'
import {
  getActivityCategories,
  getMenuCategories,
} from '../WaitingList/store/Actions'

const Bootstrap = () => {
  const [startDateHook, setStartDateHook] = useState<Moment | undefined>(
    undefined,
  )

  const [endDateHook, setEndDateHook] = useState<Moment | undefined>(undefined)
  const [isRangePickerVisible, setIsRangePickerVisible] = useState(false)

  const activeEstablishment = useAppSelector(activeEstablishmentSelector)
  const dispatch = useAppDispatch()

  useEffect(() => {
    const establishmentId = activeEstablishment.id.toString()
    dispatch(getActivityCategories(establishmentId))
    dispatch(getMenuCategories(establishmentId))
  }, [activeEstablishment])

  return (
    <Switch>
      <Route path="/calendar/last-minutes" component={OverviewLastMinute} />
      <Route
        path="/calendar/waiting-list/create"
        render={() => (
          <Create
            onSubmit={waitingCustomer => {
              setStartDateHook(moment(waitingCustomer.wanted_at))
              setEndDateHook(moment(waitingCustomer.wanted_at))
            }}
          />
        )}
      />
      <Route
        path="/calendar/waiting-list/:startDate?/:endDate?"
        render={() => (
          <Overview
            isRangePickerVisible={isRangePickerVisible}
            setIsRangePickerVisible={setIsRangePickerVisible}
            startDateHook={startDateHook || undefined}
            endDateHook={endDateHook || undefined}
            setStartDateHook={setStartDateHook}
            setEndDateHook={setEndDateHook}
          />
        )}
      />
    </Switch>
  )
}

export default Bootstrap
